//Vercel Api
export const Base_Url = "https://prod-api.jobmongo.mkisan.com/api";
